module.exports = __webpack_public_path__ + "img/info_btn.fa83ac10.png";